
import { useEffect } from "react";
import { useToast } from "@/hooks/use-toast";
import { useApp } from "@/context/AppContext";

export function usePetNotifications() {
  const { state } = useApp();
  const { toast } = useToast();

  useEffect(() => {
    if (!state.petCollection) return;
    
    // Check for pets ready to evolve to mounts
    const readyToEvolve = state.petCollection.pets.filter(pet => 
      pet.food_fed >= pet.food_needed && pet.type === 'pet'
    );

    if (readyToEvolve.length > 0) {
      toast({
        title: "🌟 Mount Evolution Available!",
        description: `${readyToEvolve.length} pet(s) are ready to evolve into mounts! Visit your Pet Collection to evolve them.`,
        duration: 6000,
      });
    }
    
    // Check for inventory space warnings
    if (state.petCollection.inventory.length > 50) {
      toast({
        title: "📦 Inventory Getting Full",
        description: "Consider hatching some pets or feeding existing ones to make space for new drops!",
        duration: 4000,
      });
    }
  }, [state.petCollection, toast]);
}
